import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { aiAgentColors } from 'constants/aiAgentColors';

import { Button } from '../../../../components/Button';

const chipGradientBorder = `linear-gradient(#fff, #fff), linear-gradient(90deg, ${aiAgentColors.gradient.blue} 1%, ${aiAgentColors.gradient.green} 100%)`;

export const StyledPredefinedChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 20px;
`;

export const StyledPredefinedChip = styled(Button)`
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  border-radius: 25px;
  border: 1px solid ${colorsPalettes.carbon[100]};
  background: ${colorsPalettes.carbon[0]};
  box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);
  ${setFontVariant('chip1', colorsPalettes.carbon[300])};
  transition: all 0.15s;
  white-space: nowrap;

  &:hover,
  &:active {
    border-color: transparent;
    background-image: ${chipGradientBorder};
    background-origin: border-box;
    background-clip: padding-box, border-box;
    background-color: transparent;
    color: ${colorsPalettes.carbon[400]};
  }

  &:disabled {
    opacity: 0.4;
    &:hover {
      border-color: ${colorsPalettes.carbon[100]};
      background-image: none;
      background: ${colorsPalettes.carbon[0]};
    }
  }
`;

export const StyledChatBar = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid ${colorsPalettes.carbon[100]};
  background: ${colorsPalettes.carbon[0]};
  flex-shrink: 0;
`;

export const StyledChatInputWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: 24px;
  padding: 8px 12px 8px 16px;
  background-image:
    linear-gradient(${colorsPalettes.carbon[0]}, ${colorsPalettes.carbon[0]}),
    linear-gradient(90deg, ${aiAgentColors.gradient.blue} 1%, ${aiAgentColors.gradient.green} 100%);
  background-origin: border-box;
  background-clip: padding-box, border-box;
`;

export const StyledChatInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  ${setFontVariant('body2', colorsPalettes.carbon[500])};
  background: transparent;

  &::placeholder {
    color: ${colorsPalettes.carbon[200]};
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const StyledSendButton = styled(Button)<{ hasText?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, ${aiAgentColors.gradient.blue} 1%, ${aiAgentColors.gradient.green} 100%);
  opacity: ${({ hasText }) => (hasText ? 1 : 0.5)};
  transition: opacity 0.15s;

  &:hover,
  &:active {
    background: linear-gradient(135deg, ${aiAgentColors.gradient.blue} 1%, ${aiAgentColors.gradient.green} 100%);
    opacity: 1;
  }

  &:disabled {
    opacity: 0.35;
    background: linear-gradient(135deg, ${aiAgentColors.gradient.blue} 1%, ${aiAgentColors.gradient.green} 100%);
  }
`;
